import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { Helpers } from './helpers';
import { setTheme } from 'ngx-bootstrap/utils';
import { BsLocaleService} from 'ngx-bootstrap/datepicker';
import { defineLocale, trLocale } from 'ngx-bootstrap/chronos';
import { Title } from '@angular/platform-browser';
import { environment } from './../environments/environment';

@Component({
  selector: 'body',
  templateUrl: './app.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit {
  globalBodyClass = 'm-page--loading-non-block m-page--fluid m--skin- m-content--skin-light2 m-header--fixed m-header--fixed-mobile m-aside-left--enabled m-aside-left--skin-dark m-aside-left--offcanvas m-footer--push m-aside--offcanvas-default';

  constructor(
    private _router: Router,
    private _localeService: BsLocaleService,
    private titleService: Title) {
    setTheme('bs4');
    defineLocale('tr', trLocale);
    this._localeService.use('tr');
  }

  ngOnInit() {
    this.titleService.setTitle('VBT Yazılım A.Ş.');
    document.getElementById('appFavicon').setAttribute('href', 'assets/app/media/img/logos/favicon.ico');

    if (environment.Key === 'SANKOTEST' || environment.Key === 'SANKOPROD') {
      this.titleService.setTitle('Sankonline');
      document.getElementById('appFavicon').setAttribute('href', 'assets/app/media/img/logos/sanko.ico');
    }

    this._router.events.subscribe((route) => {
      if (route instanceof NavigationStart) {
        Helpers.setLoading(true);
        Helpers.bodyClass(this.globalBodyClass);
      }
      if (route instanceof NavigationEnd) {
        Helpers.setLoading(false);
      }
    });

    //this.registerUnload();
  }

  registerUnload() {
    window.onbeforeunload = this.onBeforeUnload;
  }

  onBeforeUnload($event) {
    // this._authService.logout();
  }
}
